module.exports = __webpack_public_path__ + "img/blue-file-icon.f946acd6.svg";